import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { Exporter } from 'src/app/domain/models/Profile';
import { excelUtils } from 'src/app/ui/util/excel-utils';
import { formatUrl } from 'src/app/ui/util/file-formats';

@Component({
  selector: 'app-admin-upload-programs-update',
  templateUrl: './admin-upload-programs-update.component.html',
  styleUrls: ['./admin-upload-programs-update.component.css'],
  providers: [ConfirmationService],
})
export class AdminUploadProgramsUpdateComponent implements OnInit {
  excelFile: any;
  excelSheets: any;
  selectedSheet: string = '';
  loading: boolean = false;
  uploadFile: any[] = [];
  uploadDisabled: boolean = true;
  enableUploadProgramButton: boolean = false;
  enableExportProgramsButton: boolean = false;
  loadingBtnDownload = false;
  years: number[] = [];
  endYearOptions: number[] = [];

  startYear?: number;
  endYear?: number;

  form: FormGroup = this._formBuilder.group({
    exporterUsername: [null, Validators.required],
  });

  constructor(
    private _messageService: MessageService,
    private translate: TranslateService,
    private _directSaleProgramService: DirectSaleProgramGateway,
    private _profileService: ProfileGateway,
    private _formBuilder: FormBuilder,
  ) {}

  exporters: Exporter[] = [];

  ngOnInit(): void {
    this.getExporters();

    const currentYear = new Date().getFullYear();
    const range = 10;

    this.years = Array.from({ length: range }, (_, i) => currentYear - i);
  }

  onStartYearChange(year: number) {
    this.startYear = year;
    this.endYear = undefined;
    this.endYearOptions = this.years.filter((y) => y >= year);

    this.getEnableExportButton();
  }

  getEnableExportButton(): void {
    if (
      this.form.controls['exporterUsername'].value &&
      this.startYear != undefined &&
      this.endYear != undefined
    ) {
      this.enableExportProgramsButton = true;
    } else {
      this.enableExportProgramsButton = false;
    }
  }

  onEndYearChange(year: number) {
    this.getEnableExportButton();
  }

  downloadProgramsExcel() {
    this.loadingBtnDownload = true;
    if (this.startYear != undefined && this.endYear != undefined) {
      this._directSaleProgramService
        .downloadUserPrograms(
          this.form.controls['exporterUsername'].value,
          this.startYear,
          this.endYear,
        )
        .subscribe({
          next: (resultBlob: any) => {
            const contentDisposition = resultBlob.headers.get(
              'content-disposition',
            );
            let nombreArchivo = 'Programs_';

            if (contentDisposition) {
              const match = contentDisposition.match(/filename=([^]+);/);
              if (match && match[1]) {
              }
              nombreArchivo += match[1];
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);

            this.loadingBtnDownload = false;
          },
          error: (e) => {
            this.loadingBtnDownload = false;
            this._messageService.add({
              severity: 'error',
              summary: this.translate.instant(
                'MessageService.Summary.FailedAction',
              ),
              detail: this.translate.instant(
                'UserPages.PackingListView.ErrorDownloadPDF',
              ),
            });
          },
          complete: () => {
            this.loadingBtnDownload = false;
          },
        });
    }
  }

  sendFiles() {
    this.loading = true;
    console.log(this.form.value);
    if (this.uploadFile[0] && !this.form.invalid) {
      const request: any = {
        file: this.uploadFile[0],
        exporterUsername: this.form.controls['exporterUsername'].value,
      };

      this._directSaleProgramService.uploadUpdatePrograms(request).subscribe({
        next: (v) => {
          this._messageService.add({
            severity: 'success',
            summary: this.translate.instant(
              'MessageService.Summary.SuccessAction',
            ),
            detail: 'Programas actualizados correctamente',
          });
          this.loading = false;
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant(
              'MessageService.Summary.FailedAction',
            ),
            detail: e.error,
          });
        },
      });
    } else {
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.FailFileAction'),
      });
      this.loading = false;
    }
  }

  onSelect(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  onRemove(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  onClear(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  getExporters() {
    this.exporters = [];
    this.loading = true;
    this._profileService.getAllExporters().subscribe({
      next: (v) => {
        this.exporters = v;
        this.loading = false;
      },
      error: (e) => {
        console.log(e);
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant(
            'MessageService.Summary.FailedAction',
          ),
          detail: this.translate.instant(
            'MessageService.Exporter.ManyRetrieveError',
          ),
        });
      },
      complete: () => console.info('Importers query successfully'),
    });
  }

  onChangeExporter() {
    if (this.form.controls['exporterUsername'].value) {
      this.enableUploadProgramButton = true;
    } else {
      this.enableUploadProgramButton = false;
    }

    this.getEnableExportButton();
  }
}
